<template>
  <div class="sign-result-page">
    <img :src="resultImg" />
    <p class="result">
      {{
        approvalStatus === 2
          ? "您的签署申请审核未通过!"
          : "您的签署申请已提交审核， 请耐心等待~"
      }}
    </p>
    <div class="tips">
      {{
        approvalStatus === 2
          ? `失败原因：${refuseReason}`
          : "审核结果将在3个工作日内完成，请关注短信通知"
      }}
    </div>
    <cube-button
      class="btn"
      :class="{ fail_btn: approvalStatus === 2 }"
      @click="clickFn"
      >{{ approvalStatus === 2 ? "重新签署" : "返回首页" }}</cube-button
    >
  </div>
</template>

<script>
import Bus from "@/utils/Bus";
import api from "@/utils/api";
export default {
  data() {
    return {
      userId: "",
      resultImg: "",
      approvalStatus: "",
      refuseReason: ""
    };
  },
  watch: {
    // 监听审核状态
    approvalStatus: {
      handler(val) {
        if (val === 2) {
          this.resultImg = require("@/assets/image/bs-2.0/fail.png");
        } else {
          this.resultImg = require("@/assets/image/bs-2.0/success.png");
        }
      },
      immediate: true
    }
  },
  created() {
    Bus.$emit("hide-loading");
    const { userId, submitResult } = this.$route.query;
    this.userId = userId;
    this.submitResult = submitResult;
    this.queryAgreement();
  },
  mounted() {
    if (this.submitResult) {
      // 保存录屏
      if (clairvoyanceRecord) {
        clairvoyanceRecord.save();
        clairvoyanceRecord.finish({
          notStopRecord: true,
          policyId: this.userId
        });
      }
    }
  },
  methods: {
    // 查询用户协议
    queryAgreement() {
      api.getWebuserAgreementByUserId(this.userId).then(res => {
        const data = res.data;
        if (data.returnCode === "0000" && data.content) {
          const { approvalStatus, refuseReason } = data.content;
          this.approvalStatus = approvalStatus;
          this.refuseReason = refuseReason;
        }
      });
    },
    // 按钮点击
    clickFn() {
      if (this.approvalStatus === 0) {
        let url =
          "http://wx.run4wd.com/authority/wxstore/index?param=MVLNuKLeew3P58WQdOKfF1v8Ji7Ynp2I201ZPa1141r2i79mZOvEkry7DbgSdS-lU4dSSO9Ngndzb4z_-6e5LhLek4bsTNWuoe06q6UYG80=";

        if (/localhost/.test(location.href)) {
          url =
            "http://localhost/authority/wxstore/index?param=MVLNuKLeew3P58WQdOKfF1v8Ji7Ynp2I201ZPa1141r2i79mZOvEkry7DbgSdS-lU4dSSO9Ngndzb4z_-6e5LhLek4bsTNWuoe06q6UYG80=";
        } else if (
          /ssish/.test(location.href) ||
          /yutai365/.test(location.href)
        ) {
          url =
            "http://wx.ssish.com/authority/wxstore/index?param=h9EWoSZVPTOwhoz1hP0UvK_BjMddzZkVXwhjGPoRb9Ghcg0OQSMhr3vCJUgffmaEoiULwr4CnE-yjxnS6KQ7bpc9UzeJXRLdy91kRaiiRM4=";
        }
        window.location.href = url;
      } else {
        const cporpa = this.$route.query.cporpa;
        const isOld = this.$route.query.isOld;
        const name = cporpa === "1" ? "agreementNotices" : "agreementSign";
        this.$router.push({
          name,
          query: { userId: this.userId, cporpa, isOld, type: "resign" }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-result-page {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #333333;
  line-height: 20px;
  text-align: center;
  img {
    width: 97px;
    height: 97px;
    margin: 66px auto 9px;
  }
  .result {
    width: 168px;
    margin: auto;
    margin-bottom: 6px;
  }
  .tips {
    font-size: 12px;
    color: #cccccc;
    line-height: 17px;
  }
  .btn {
    position: absolute;
    bottom: 34px;
    left: 50%;
    transform: translateX(-50%);
    width: 331px;
    height: 45px;
    background: #eaeaea;
    border-radius: 7px;
    font-size: 15px;
    font-weight: bold;
    color: #666666;
    &.fail_btn {
      color: #ffffff;
      background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
    }
  }
}
</style>
